<template>
  <v-modal modal-id="forgot-password-dialog" @close="close">
    <h2>{{ $t('storeUserLogin.forgotPasswordModal.title') }}</h2>
    <p>{{ $t(`storeUserLogin.forgotPasswordModal.intro`) }}</p>
    <fieldset class="warning">
      <div class="form-row inline-label">
        <div class="form-column">
          <label for="email" class="required">{{ $t(`storeUserLogin.forgotPasswordModal.form.emailLabel`) }}</label>
          <input id="email" v-model="emailAddress" type="text" name="email">
        </div>
        <ul v-if="$v.emailAddress.$error" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
          <li v-if="!$v.emailAddress.required">{{ $t('storeUserLogin.forgotPasswordModal.validation.emailAddress.required') }}</li>
          <li v-if="!$v.emailAddress.email || !$v.emailAddress.maxLength">{{ $t('storeUserLogin.forgotPasswordModal.validation.emailAddress.email') }}</li>
        </ul>
      </div>
    </fieldset>
    <fieldset class="submit">
      <button class="yes" type="button" @click.prevent="submitForm">{{ $t('storeUserLogin.forgotPasswordModal.form.submit') }}</button>
      <a class="cancel" href="#" @click.prevent="close">{{ $t('storeUserLogin.forgotPasswordModal.form.cancel') }}</a>
    </fieldset>
  </v-modal>
</template>

<script>
import VModal from './Modal'
import { validationMixin } from 'vuelidate'
import { required, email, maxLength } from 'vuelidate/lib/validators'

export default {
  components: {
    VModal
  },
  mixins: [
    validationMixin
  ],
  data () {
    return {
      emailAddress: '',
      error: null
    }
  },
  validations () {
    return {
      emailAddress: {
        required,
        email,
        maxLength: maxLength(75)
      }
    }
  },
  watch: {
    emailAddress: function () {
      this.error = null
    }
  },
  methods: {
    submitForm: async function () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$emit('submit', this.emailAddress)
      }
    },
    close: function () {
      this.$emit('close')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/StoreUserForgotPassword.vue